import React, { useCallback, useContext, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Input,
  Checkbox,
  FormGroup,
  Typography,
  Tooltip,
} from "@material-ui/core";
import _ from "lodash";
import { DashboardContext } from "../../context/DashboardContext";
import DashboardMode from "../../constants/DashboardMode";
import { UserContext } from "../../context/UserContext";
import ConfigUtils from "../../utils/ConfigUtils";
import "./filters.scss";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ReactComponent as Export } from "../../assets/icons/export.svg";
import useStateRef from "../../hooks/useStateRef";

export const draftFilter = {
  name: "My Drafts",
  group: "filters",
  field: {
    myDrafts: "DRAFT",
  },
  roles: ["admin", "ops", "requestor", "superadmin", "globaladmin"],
};
export const favFilter = {
  name: "My Favorites",
  group: "filters",
  field: {
    myFavorite: "myFavorite",
  },
  roles: ["requestor"],
};

const PresetFilter = () => {
  const PresetFilters = ConfigUtils.getPresetFilters();
  const {
    filter,
    _setFilter,
    dashboardView,
    showLoading,
    fetchReport,
    downloading,
  } = useContext(DashboardContext);
  const { userRole, favoriteRequestsIds } = useContext(UserContext);
  const [value, setValue] = useStateRef("");

  useEffect(() => {
    let allFilters = _.map(PresetFilters, (pFilter) =>
      _.keys(_.get(pFilter, "field"))
    );
    if (dashboardView === DashboardMode.REQUESTS) {
      allFilters.push(_.keys(_.get(draftFilter, "field")));
      allFilters.push(_.keys(_.get(favFilter, "field")));
    }
    allFilters = allFilters.flat();
    let _allFilter = JSON.parse(JSON.stringify(filter));
    let _jobsFilters = _.get(_allFilter, dashboardView, {});
    let pFilterKey = _.first(_.keys(_jobsFilters));
    if (_.includes(allFilters, pFilterKey)) {
      setValue(pFilterKey);
    } else {
      setValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, dashboardView]);

  const handleChange = useCallback(
    (e, fieldFilter) => {
      showLoading();
      if (e.target.checked) {
        setValue(e.target.value);
        let filterObject = {};
        if (dashboardView === DashboardMode.JOBS) {
          if (e.target.value === "myTeamData") {
            filterObject = {[e.target.value]: true, ...filter[dashboardView]};
          }else {
            filterObject = _.get(fieldFilter, "field");
          }
        } else {
          if (e.target.value === "myFavorite") {
            filterObject = { [e.target.value]: favoriteRequestsIds };
          } else if (e.target.value === "myTeamData") {
            let existingFilter = filter[dashboardView];
            if (filter[dashboardView].hasOwnProperty('myFavorite')) {
              existingFilter = _.omit(filter[dashboardView],'myFavorite');
            } else if (filter[dashboardView].hasOwnProperty('myDrafts')) {
              existingFilter = _.omit(filter[dashboardView],'myDrafts');
            }
            filterObject = {[e.target.value]: true, ...existingFilter};
          } else {
            filterObject = _.get(draftFilter, "field");
          }
        }
        _setFilter(filterObject, true);
      } else {
        if (value === "myTeamData") {
          setValue("");
          _setFilter(_.omit(filter[dashboardView],'myTeamData'), true);
        } else {
          setValue("");
          _setFilter({}, true);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setValue, _setFilter, showLoading, dashboardView, favoriteRequestsIds]
  );

  const getValue = (field) => {
    const keys = _.keys(field);
    return keys[0];
  };

  return (
    <>
      {dashboardView === DashboardMode.JOBS ? (
        <div className={`presetContainer${userRole === 'cr_api' ? ' no-preset-filter' : ''}`}>
          <FormControl component="fieldset">
            <FormGroup row aria-label="position" defaultValue="top">
              {_.map(PresetFilters, (filterObj, index) =>
                _.indexOf(filterObj.roles, userRole) !== -1 ? (
                  <FormControlLabel
                    onChange={(e) => handleChange(e, filterObj)}
                    key={"preset_" + index}
                    value={getValue(_.get(filterObj, "field"))}
                    checked={getValue(_.get(filterObj, "field")) === value}
                    control={<Checkbox className="presetFilterCheckbox" />}
                    label={
                      <Typography className="presetFilterCheckboxLabel">
                        {_.get(filterObj, "name")}
                      </Typography>
                    }
                  />
                ) : null
              )}
              <Input
                className="presetFilterHelperText"
                id="my-input"
                aria-describedby="my-helper-text"
              />
            </FormGroup>
          </FormControl>
          {downloading ? (
            <CircularProgress className="exportIcon" size={25} />
          ) : (
            <Tooltip title={"Export"} placement={"left"} arrow>
              <Export
                className="exportIcon"
                onClick={(e) => {
                  fetchReport();
                }}
              />
            </Tooltip>
          )}
        </div>
      ) : (
        <div className={`presetContainer${userRole === 'cr_api' ? ' no-preset-filter' : ''}`}>
          <div className="requestFilter">
            {_.indexOf(_.get(draftFilter, "roles"), userRole) !== -1 ? (
              <FormControl component="fieldset">
              <FormControlLabel
                onChange={handleChange}
                key={"preset_my_drafts"}
                checked={getValue(_.get(draftFilter, "field")) === value}
                value={getValue(_.get(draftFilter, "field"))}
                control={<Checkbox className="presetFilterCheckbox" />}
                label={
                  <Typography className="presetFilterCheckboxLabel">
                    {_.get(draftFilter, "name")}
                  </Typography>
                }
              />
              </FormControl>
            ) : null}
            {_.indexOf(_.get(favFilter, "roles"), userRole) !== -1 ? (
              <FormControl component="fieldset">
                <FormControlLabel
                  onChange={handleChange}
                  key={"preset_my_favourite"}
                  checked={getValue(_.get(favFilter, "field")) === value}
                  value={getValue(_.get(favFilter, "field"))}
                  control={<Checkbox className="presetFilterCheckbox" />}
                  label={
                    <Typography className="presetFilterCheckboxLabel">
                      {_.get(favFilter, "name")}
                    </Typography>
                  }
                />
              </FormControl>
            ) : null}
            {_.map(PresetFilters, (filterObj, index) =>
                _.indexOf(filterObj.roles, userRole) !== -1 && filterObj.requestFilterName ? (
                  <FormControl component="fieldset">
                  <FormControlLabel
                    onChange={handleChange}
                    key={"preset_" + index}
                    value={getValue(_.get(filterObj, "field"))}
                    checked={getValue(_.get(filterObj, "field")) === value}
                    control={<Checkbox className="presetFilterCheckbox" />}
                    label={
                      <Typography className="presetFilterCheckboxLabel">
                        {filterObj.requestFilterName}
                      </Typography>
                    }
                  />
                  </FormControl>
                ) : null
              )}
          </div>
          {downloading ? (
            <CircularProgress className="exportIcon" size={25} />
          ) : (
            <Tooltip title={"Export"} placement={"left"} arrow>
              <Export
                className="exportIcon"
                onClick={(e) => {
                  fetchReport();
                }}
              />
            </Tooltip>
          )}
        </div>
      )}
    </>
  );
};

export default PresetFilter;
